import Coupon from './Coupon'

export default function Coupons({ slides, title, subtitle, domain }) {
    return (
        <div className='min-h-[280px] md:min-h-[396px] mt-12 px-4 xl:px-0'>
            <div className='w-full overflow-x-auto'>
                <h1 className='title'>{title}</h1>
                <p className='subtitle hidden md:block'>{subtitle}</p>
                <div className='flex mt-10 gap-4 w-fit inner-container justify-between pb-6'>
                    {slides?.map(({ sliderimage, logoUrl, category, subdomain }, index) => {
                        return <Coupon subdomain={subdomain} domain={domain} key={index} logo={logoUrl} img={sliderimage} content={category} />
                    })}
                </div>
            </div>
        </div>
    )
}